
import { Sun, Zap, DollarSign, Clock } from "lucide-react";

const BenefitsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">Benefícios para seu negócio</h2>
          <p className="text-lg text-center text-gray-600">
            Entenda como nossa plataforma transforma a gestão energética da sua empresa
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <div className="space-y-8">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-hero-blue/10 flex items-center justify-center">
                  <Sun className="h-6 w-6 text-hero-blue" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">Potência Personalizada</h3>
                  <p className="text-gray-600">Sistemas dimensionados de acordo com o consumo real da sua empresa, garantindo máxima eficiência.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-hero-green/10 flex items-center justify-center">
                  <Zap className="h-6 w-6 text-hero-green" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">Geração Contínua</h3>
                  <p className="text-gray-600">Produza energia limpa e renovável todos os meses, reduzindo a dependência da rede elétrica convencional.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-highlight-yellow/10 flex items-center justify-center">
                  <DollarSign className="h-6 w-6 text-highlight-yellow" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">Economia Imediata</h3>
                  <p className="text-gray-600">Reduza significativamente os custos operacionais da sua empresa desde o primeiro mês de instalação.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-vivid-purple/10 flex items-center justify-center">
                  <Clock className="h-6 w-6 text-vivid-purple" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">Retorno Garantido</h3>
                  <p className="text-gray-600">Investimento com retorno médio em 22 meses e economia garantida por mais de 25 anos.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="order-1 md:order-2">
            <img 
              src="/lovable-uploads/4236170e-605d-409f-951a-1f3e1b0803b4.png" 
              alt="Business Benefits" 
              className="rounded-xl shadow-lg w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
